import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ValidateReceiveStockBulkUploadQueryVariables = Types.Exact<{
  input: Types.ReceiveStockBulkValidateInput;
}>;


export type ValidateReceiveStockBulkUploadQuery = { readonly __typename?: 'Query', readonly validateReceiveStockBulkUpload?: { readonly __typename?: 'ReceiveBulkValidationResult', readonly totalSent: number, readonly totalMatched: number, readonly totalErrors: number, readonly rows: ReadonlyArray<{ readonly __typename?: 'ReceiveBulkRowValidation', readonly rowIndex: number, readonly skuId?: string | null, readonly skuName?: string | null, readonly quantity?: number | null, readonly expiryDate?: string | null, readonly locationName?: string | null, readonly hasError: boolean, readonly errorMessage?: string | null }> } | null };

export type ReceiveStockBulkDownloadQueryVariables = Types.Exact<{
  facilityId: Types.Scalars['ID'];
}>;


export type ReceiveStockBulkDownloadQuery = { readonly __typename?: 'Query', readonly receiveStockBulkDownload: { readonly __typename?: 'BulkDownloadResult', readonly totalCount: number, readonly csv: string } };

export type ReceiveStockBulkUploadMutationVariables = Types.Exact<{
  input: Types.ReceiveStockBulkUploadInput;
}>;


export type ReceiveStockBulkUploadMutation = { readonly __typename?: 'Mutation', readonly receiveStockBulkUpload: { readonly __typename?: 'BulkUploadResult', readonly totalSent: number, readonly totalAdditions: number, readonly totalUpdates: number, readonly totalErrors: number, readonly errors: ReadonlyArray<{ readonly __typename?: 'BulkUploadError', readonly id: string, readonly errorMessage?: string | null }> } };


export const ValidateReceiveStockBulkUploadDocument = gql`
    query validateReceiveStockBulkUpload($input: ReceiveStockBulkValidateInput!) {
  validateReceiveStockBulkUpload(input: $input) {
    totalSent
    totalMatched
    totalErrors
    rows {
      rowIndex
      skuId
      skuName
      quantity
      expiryDate
      locationName
      hasError
      errorMessage
    }
  }
}
    `;

/**
 * __useValidateReceiveStockBulkUploadQuery__
 *
 * To run a query within a React component, call `useValidateReceiveStockBulkUploadQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateReceiveStockBulkUploadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateReceiveStockBulkUploadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateReceiveStockBulkUploadQuery(baseOptions: Apollo.QueryHookOptions<ValidateReceiveStockBulkUploadQuery, ValidateReceiveStockBulkUploadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateReceiveStockBulkUploadQuery, ValidateReceiveStockBulkUploadQueryVariables>(ValidateReceiveStockBulkUploadDocument, options);
      }
export function useValidateReceiveStockBulkUploadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateReceiveStockBulkUploadQuery, ValidateReceiveStockBulkUploadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateReceiveStockBulkUploadQuery, ValidateReceiveStockBulkUploadQueryVariables>(ValidateReceiveStockBulkUploadDocument, options);
        }
export type ValidateReceiveStockBulkUploadQueryHookResult = ReturnType<typeof useValidateReceiveStockBulkUploadQuery>;
export type ValidateReceiveStockBulkUploadLazyQueryHookResult = ReturnType<typeof useValidateReceiveStockBulkUploadLazyQuery>;
export type ValidateReceiveStockBulkUploadQueryResult = Apollo.QueryResult<ValidateReceiveStockBulkUploadQuery, ValidateReceiveStockBulkUploadQueryVariables>;
export const ReceiveStockBulkDownloadDocument = gql`
    query receiveStockBulkDownload($facilityId: ID!) {
  receiveStockBulkDownload(facilityId: $facilityId) {
    totalCount
    csv
  }
}
    `;

/**
 * __useReceiveStockBulkDownloadQuery__
 *
 * To run a query within a React component, call `useReceiveStockBulkDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useReceiveStockBulkDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReceiveStockBulkDownloadQuery({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *   },
 * });
 */
export function useReceiveStockBulkDownloadQuery(baseOptions: Apollo.QueryHookOptions<ReceiveStockBulkDownloadQuery, ReceiveStockBulkDownloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReceiveStockBulkDownloadQuery, ReceiveStockBulkDownloadQueryVariables>(ReceiveStockBulkDownloadDocument, options);
      }
export function useReceiveStockBulkDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReceiveStockBulkDownloadQuery, ReceiveStockBulkDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReceiveStockBulkDownloadQuery, ReceiveStockBulkDownloadQueryVariables>(ReceiveStockBulkDownloadDocument, options);
        }
export type ReceiveStockBulkDownloadQueryHookResult = ReturnType<typeof useReceiveStockBulkDownloadQuery>;
export type ReceiveStockBulkDownloadLazyQueryHookResult = ReturnType<typeof useReceiveStockBulkDownloadLazyQuery>;
export type ReceiveStockBulkDownloadQueryResult = Apollo.QueryResult<ReceiveStockBulkDownloadQuery, ReceiveStockBulkDownloadQueryVariables>;
export const ReceiveStockBulkUploadDocument = gql`
    mutation receiveStockBulkUpload($input: ReceiveStockBulkUploadInput!) {
  receiveStockBulkUpload(input: $input) {
    totalSent
    totalAdditions
    totalUpdates
    totalErrors
    errors {
      id
      errorMessage
    }
  }
}
    `;
export type ReceiveStockBulkUploadMutationFn = Apollo.MutationFunction<ReceiveStockBulkUploadMutation, ReceiveStockBulkUploadMutationVariables>;

/**
 * __useReceiveStockBulkUploadMutation__
 *
 * To run a mutation, you first call `useReceiveStockBulkUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReceiveStockBulkUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [receiveStockBulkUploadMutation, { data, loading, error }] = useReceiveStockBulkUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReceiveStockBulkUploadMutation(baseOptions?: Apollo.MutationHookOptions<ReceiveStockBulkUploadMutation, ReceiveStockBulkUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReceiveStockBulkUploadMutation, ReceiveStockBulkUploadMutationVariables>(ReceiveStockBulkUploadDocument, options);
      }
export type ReceiveStockBulkUploadMutationHookResult = ReturnType<typeof useReceiveStockBulkUploadMutation>;
export type ReceiveStockBulkUploadMutationResult = Apollo.MutationResult<ReceiveStockBulkUploadMutation>;
export type ReceiveStockBulkUploadMutationOptions = Apollo.BaseMutationOptions<ReceiveStockBulkUploadMutation, ReceiveStockBulkUploadMutationVariables>;